import { SUPABASE_URL, supabaseHeaders } from '../supabase';

const compressImage = (file, maxWidth = 800, quality = 0.8) =>
  new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = Math.min(1, maxWidth / img.width);
      const canvas = document.createElement('canvas');
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;
      const ctx = canvas.getContext('2d');
      // JPEG has no alpha channel, so a transparent PNG's see-through areas would otherwise come
      // out black (canvas defaults unpainted pixels to transparent black) once flattened.
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality);
    };
    img.src = url;
  });

export const uploadPoster = async (file) => {
  const compressed = await compressImage(file);
  const fileName = `${Date.now()}-${Math.random().toString(36).slice(2)}.jpg`;

  const res = await fetch(`${SUPABASE_URL}/storage/v1/object/posters/${fileName}`, {
    method: 'POST',
    headers: { ...supabaseHeaders(true), 'Content-Type': 'image/jpeg' },
    body: compressed,
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Upload failed: ${err}`);
  }

  return `${SUPABASE_URL}/storage/v1/object/public/posters/${fileName}`;
};
